/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetSyncHistorySyncRunIdParamsOperation = typeof GetSyncHistorySyncRunIdParamsOperation[keyof typeof GetSyncHistorySyncRunIdParamsOperation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetSyncHistorySyncRunIdParamsOperation = {
  GetSyncHistorySyncRunIdParamsOperationCreate: 'create',
  GetSyncHistorySyncRunIdParamsOperationDelete: 'delete',
  GetSyncHistorySyncRunIdParamsOperationDownload: 'download',
  GetSyncHistorySyncRunIdParamsOperationError: 'error',
  GetSyncHistorySyncRunIdParamsOperationSummary: 'summary',
  GetSyncHistorySyncRunIdParamsOperationUpdate: 'update',
  GetSyncHistorySyncRunIdParamsOperationWarning: 'warning',
} as const;
